
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'LazyScript',
    props: {
        src: {
            required: true,
            type: String,
        },
        type: {
            required: false,
            default: 'text/javascript',
            type: String,
        },
    },
    emits: ['onload'],
    setup(props, { emit, attrs, slots }) {
        const scriptIsAppended = computed(() => {
            const sameScriptAppend = document.head.querySelectorAll(`script[src='${props.src}']`);
            return sameScriptAppend.length > 0;
        });

        const onload = () => {
            emit('onload');
        };

        const appendScript = () => {
            const script = document.createElement('script');
            script.type = props.type;
            script.async = false;
            script.src = props.src;
            script.onload = onload;
            document.head.appendChild(script);
        };

        scriptIsAppended.value ? onload() : appendScript();

        return () => null;
    },
});
